
/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'beatpulse_icon': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<defs><linearGradient x1="-.007%" y1="50.034%" x2="100.013%" y2="50.034%" id="svgicon_beatpulse_icon_a"><stop stop-color="#FF7B23" offset="0%"/><stop stop-color="#FF5623" offset="100%"/></linearGradient></defs><path pid="0" d="M2.118 15.295L8.026 7.25a.622.622 0 0 1 .683-.223.604.604 0 0 1 .432.565l.147 8.813a.618.618 0 0 0 1.177.236l4.17-9.125a.618.618 0 0 1 .668-.349.607.607 0 0 1 .508.55l.507 6.606c.02.251.195.464.442.534a.622.622 0 0 0 .665-.22l4.452-5.859a.593.593 0 0 0-.015-.741.624.624 0 0 0-.738-.165L2.878 16.196a.625.625 0 0 1-.737-.162.594.594 0 0 1-.023-.74z" _fill="url(#svgicon_beatpulse_icon_a)" fill-rule="evenodd"/>'
  }
})
